<template>
  <el-dialog
    title="Edit profile"
    :visible.sync="formModalOpened"
    :before-close="handleClose"
  >
    <profile-form ref="form" :userId="userFromContext.id" :profile="userFromContext.profile" :showButton="false" :onSuccess="handleClose" />

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleClickSubmit" :loading="saving">Save</el-button>
      <el-button @click="handleClose">Close</el-button>
    </span>

  </el-dialog>

</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  import ProfileForm from '@/components/profile/UserProfileForm';

  export default {
    name: 'UserProfileFormModal',
    components: {
      profileForm: ProfileForm,
    },
    computed: {
      ...mapGetters('entities/users', ['userFromContext']),
      ...mapGetters('entities/profiles', ['creating', 'isUpdating']),

      formModalOpened: {
        get() {
          return this.$store.getters['entities/profiles/formModalOpened'];
        },
        set(newValue) {
          if (!newValue) {
            this.closeFormModal();
          }
        },
      },

      editMode() {
        return this.userFromContext.profile;
      },

      saving() {
        return this.editMode ? this.isUpdating(this.userFromContext.profile.id) : this.creating;
      },

    },
    methods: {
      ...mapActions('entities/profiles', ['closeFormModal']),

      handleClickSubmit() {
        this.$refs.form.submitForm();
      },

      handleClose() {
        this.closeFormModal();
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/profile/UserProfileFormModal.vue